import router from '../../../router'
import NavigationBar from '../../../components/navigation-bar/NavigationBar'
import TabBar from '../../../components/tab-bar/TabBar'
import InputButton from '../../../components/input-button/InputButton'
import InputText from '../../../components/input-text/InputText'
import Loader from '../../../components/loader/Loader'
import { SortedTable, SortLink } from 'vue-sorted-table'
import { ScreenLoader } from '../../../utils/loading.util'
import { GroupService, Group } from '../../../services/group.service'
import InputDropdown from "@/components/input-dropdown/InputDropdown";
import {LocationDropdown, LocationService} from "@/services/location.service";

export default {
    name: 'Groups',
    components: {
        InputDropdown,
        NavigationBar,
        TabBar,
        InputButton,
        InputText,
        SortedTable,
        SortLink,
        Loader
    },

    data() {
        return {
            searchValue: '',
            groups: [],
            sortedGroups: [],
            screenLoader: new ScreenLoader(),
            locations: [new LocationDropdown({id: -1, name: "Show all locations"})],
            selectedLocation: "Show all locations",
        }
    },

    async mounted() {
        await this.getGroups()
        const locations = await LocationService.getLocations()
        this.locations = [...this.locations, ...locations.map(l => new LocationDropdown(l))]
    },

    methods: {
        doAdd() {
            router.push(`/settings/groups/new`)
        },

        selectRow(rowId) {
            router.push(`/settings/groups/${rowId}`)
        },

        search() {
            this.sortedGroups = this.groups.filter(group => {
                const foundName = this.propertyContainsValue(group.name)
                const foundEntity = this.propertyContainsValue(group.getEntities())

                return foundName || foundEntity
            })
        },

        propertyContainsValue(value) {
            return value ? value.toLowerCase().includes(this.searchValue.toLowerCase()) : false
        },

        clearSearch() {
            this.searchValue = ''
            this.sortedGroups = this.groups
        },

        getGroups: async function() {
            this.screenLoader.start()

            try {
                const groups = await GroupService.getGroups()
                this.handleGroupsResponse(groups)
            }catch(error) {
                this.screenLoader.stopWithError(error)
            }
        },

        handleGroupsResponse(groups) {
            this.groups = groups.map(o => new Group(o))
            this.sortedGroups = this.groups
            this.screenLoader.stop()
        },

        updateLocationFilter(locationId) {
            this.selectedLocation = this.locations.find(l => l.id === locationId).value
            if (locationId === -1) {
                this.search()
            } else {
                this.sortedGroups = this.groups.filter((group) => {
                    return group.location.id === locationId
                })
            }
        }
    }
}
